// extracted by mini-css-extract-plugin
export default {"container":"_base-content_container_oSPZI","mainHeading":"_base-content_mainHeading_ADNoo"};